import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type PersonProps = IconComponentBaseProps;

export const Person = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[6],
}: PersonProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask
        id="mask0_8565_176426"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_8565_176426)">
        <path
          d="M12 11.6923C11.0375 11.6923 10.2136 11.3496 9.52825 10.6643C8.84275 9.97876 8.5 9.15476 8.5 8.19226C8.5 7.22976 8.84275 6.40584 9.52825 5.72051C10.2136 5.03501 11.0375 4.69226 12 4.69226C12.9625 4.69226 13.7864 5.03501 14.4718 5.72051C15.1573 6.40584 15.5 7.22976 15.5 8.19226C15.5 9.15476 15.1573 9.97876 14.4718 10.6643C13.7864 11.3496 12.9625 11.6923 12 11.6923ZM4.5 17.7885V17.0845C4.5 16.5948 4.633 16.1413 4.899 15.724C5.165 15.3067 5.5205 14.9858 5.9655 14.7615C6.95383 14.277 7.95092 13.9136 8.95675 13.6713C9.96258 13.4289 10.977 13.3078 12 13.3078C13.023 13.3078 14.0374 13.4289 15.0433 13.6713C16.0491 13.9136 17.0462 14.277 18.0345 14.7615C18.4795 14.9858 18.835 15.3067 19.101 15.724C19.367 16.1413 19.5 16.5948 19.5 17.0845V17.7885C19.5 18.2102 19.3523 18.5688 19.0568 18.8645C18.7613 19.16 18.4026 19.3078 17.9808 19.3078H6.01925C5.59742 19.3078 5.23875 19.16 4.94325 18.8645C4.64775 18.5688 4.5 18.2102 4.5 17.7885ZM6 17.8078H18V17.0845C18 16.882 17.9413 16.6945 17.824 16.522C17.7067 16.3497 17.5474 16.209 17.3462 16.1C16.4846 15.6757 15.6061 15.3542 14.7107 15.1355C13.8152 14.917 12.9117 14.8078 12 14.8078C11.0883 14.8078 10.1848 14.917 9.28925 15.1355C8.39392 15.3542 7.51542 15.6757 6.65375 16.1C6.45258 16.209 6.29333 16.3497 6.176 16.522C6.05867 16.6945 6 16.882 6 17.0845V17.8078ZM12 10.1923C12.55 10.1923 13.0208 9.99643 13.4125 9.60476C13.8042 9.21309 14 8.74226 14 8.19226C14 7.64226 13.8042 7.17143 13.4125 6.77976C13.0208 6.38809 12.55 6.19226 12 6.19226C11.45 6.19226 10.9792 6.38809 10.5875 6.77976C10.1958 7.17143 10 7.64226 10 8.19226C10 8.74226 10.1958 9.21309 10.5875 9.60476C10.9792 9.99643 11.45 10.1923 12 10.1923Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
